import React from 'react'
import {LogoLarge, LogoSmall} from "./logo";
import {connect} from 'react-redux'
import AppButton from "./button";
import {Popover, Row, Space} from "antd";
import {login} from "../redux/actions";
import {UserOutlined} from "@ant-design/icons";
import {Link} from "react-router-dom";
import GithubOutlined from "@ant-design/icons/es/icons/GithubOutlined";

const AppHeader = ({
    mini=false,
    loggedIn,
    address,
    project,
    transparent,
    ...props
})=>{

    console.log(project)

    return <Row justify={'space-between'} align={'middle'} className={`no-margin padding-x ${mini && (!transparent) && 'padding-sm dark-blue-bg'}`}>
        <span>
        <Link to={'/'} className={'margin-sm'}>
        {
            mini && !transparent ?
                <LogoSmall/>
                :
                <LogoLarge/>
        }
        </Link>
            {
                mini && !transparent &&
                <Space className={'padding-x'}><span className={'underline'}>{project?.name}</span> {project?.name &&
                <a href={'https://github.com'} className={'white font-sm bold'}><GithubOutlined/> Github Repo</a>}</Space>
            }
            </span>
        <Row align={'top'}>
            <Row align={'middle'} >
                {
                    address
                }
                <div className={'margin-x'}>
                {
                    address &&
                        <Popover

                        content={
                            <Space onClick={()=>{
                            props.dispatch(login(false))
                            }
                            }
                                   className={'pointer'}
                            >
                                Logout
                            </Space>
                        }
                        >
                    <UserOutlined className={'font-xl circle pointer'} />
                        </Popover>
                }
                </div>
            </Row>
<div>
    {
        !mini &&


            <AppButton
                to={loggedIn && !mini && '/projects'}
                success stylized

                       onClick={()=>{
                           if(!loggedIn)
                               props.dispatch(login(true))
                       }}
            >
                {
                    loggedIn?
                        'GO TO CONSOLE'
                        :
                        "LOGIN"
                }
            </AppButton>

    }
</div>
        </Row>

    </Row>
}

const mapStateToProps = (store) => ({
    loggedIn: store.appReducer.loggedIn,
    address: store.appReducer.address,
    project: store.appReducer.project

})

export default connect(mapStateToProps)(AppHeader)